import api from "../../../api.js";

export const CREATE_FREELANCE_STEPS = {
  'CONTACT' : '0',
  'VISIO' : '1',
  'CV' : '2',
  'ADDITIONAL_INFO' : '3',
  'VISIO_RECAP' : '4',
  'PRESENTATION' : '5',
  'MISSIONS' : '6',
  'VALIDATION' : '7',
}


const updateCreatFreelanceStep = async (freelanceId, step, callback) => {
  await api.freelances.editStep({
    freelance: freelanceId,
    current_registration_step: step
  })

  if(callback) {
    await callback()
  }
};

export {updateCreatFreelanceStep}